import axios from "axios";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/app";
import type { Config } from "./services";
import "./index.css";

type RuntimeConfig = Config & { googleAnalyticsId?: string };

void axios.get<RuntimeConfig>("/config.json").then((response) => {
  const config = response.data;

  if (config.googleAnalyticsId && window.ga) {
    window.ga("create", config.googleAnalyticsId, "auto");
    window.ga("send", "pageview");
  }

  const container = document.getElementById("root");
  if (!container) {
    throw new Error("#root element is missing");
  }

  createRoot(container).render(
    <React.StrictMode>
      <App config={config} />
    </React.StrictMode>,
  );
});
